/**
 * Configuration Supabase pour SSO
 * 
 * Ce fichier configure le client Supabase uniquement pour le SSO.
 * Le module conserve son propre système d'authentification local.
 */

import { createClient } from '@supabase/supabase-js'

// Variables d'environnement Supabase (pour SSO uniquement)
// Note: Create React App utilise process.env.REACT_APP_* au lieu de import.meta.env.VITE_*
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_ANON_KEY doivent être définis dans les variables d\'environnement.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: window.sessionStorage,
  }
})
